import React, { Component } from "react";
import NavbarV2 from "./NavbarV2";
import Footerv2 from "./Footerv2";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Auth from "../../models/Auth";
import settings from "../../settings";
import FetchResponses from "../../models/FetchResponses";
import Logger from "../../models/Logger";
import { Messages, translateDetails } from "../../models/Messages";
import TagManager from 'react-gtm-module'
import { generateSHA256Hash } from "../../models/Helpers";
import { connect } from "react-redux";
import { setModulos } from "../Actions/Modules_Actions";
import { SetPerfil } from "../Actions/Perfil_Actions";
import { setDataLandingTotal } from "./landing_Actions";
import { Redirect } from "react-router-dom/cjs/react-router-dom";
import Error from "./Error";
import PageLoader from "../GlobalComponents/PageLoader";
import CustomIcons from "../GlobalComponents/CustomIcons";

class Loginv2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      parameters: {
        title: '',
        content: '',
        imagen: '',
        data: {
          toggle: {
            google: false,
            facebook: false
          }
        }
      },
      loading: false,
      type: 'password',
      show: false,
      fiscal_number: "",
      password: "",
      error_message: "",
      open: false,
      modules: [],
      pending_information: false,
      googleLogin: false,
      facebookLogin: false
    };
  }

  componentDidMount () {
    this.getLoginParams()
  }


  onClick = event => {
    event.preventDefault();
    let show = !this.state.show;
    this.setState(this.managePassword(show));
  };

  managePassword = show => {
    let type = show ? "text" : "password";
    return { type, show };
  };

  validateFields = () => {
    return (
      this.state.fiscal_number.length >= 4 && this.state.password.length >= 4
    );
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  sendDataLayerLoginSuccessfull = async () => {
    let userid = await generateSHA256Hash(this.state.fiscal_number);
    let tagManagerArgs = {
      event: "Login-successfull",
      category: "Interacciones Login",
      action: "Login successfull",
      userid,
    };
    TagManager.dataLayer({
      dataLayer: tagManagerArgs,
    });
  };


  getLoginParams = async () => {
    let url = settings.backend.generalParameters + 1 + '/'
    fetch(url, {
      method: "GET",
      headers: settings.headers_super_auth,
    })
      .then(FetchResponses.processResponse)
      .then((response) => {
        this.setState({parameters: response})
      })
      .catch(this.failureLogin);
  }

  login = (event) => {
    event.preventDefault();
    this.sendDataLayerLoginSuccessfull();
    this.setState({ loading: true });

    const data = {
      fiscal_number: this.state.fiscal_number,
      password: this.state.password,
    };

    fetch(settings.backend.login, {
      method: "POST",
      body: JSON.stringify(data),
      headers: settings.headers_super_auth,
    })
      .then(FetchResponses.processResponse)
      .then(this.successLogin)
      .catch(this.failureLogin);
  };

  successResponse = (response) => {
    this.props.setDataLandingTotal(response);
    localStorage.setItem("footer", JSON.stringify(response.modules));
    this.setState({
      landing: this.props.landing,
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  successLogin = (response) => {

    
    Logger.warn("Success Login: " + JSON.stringify(response));
    this.setState({
        modules: response.modules
    })
    Auth.loginUser(response.token, response.is_admin);
    Auth.setPermissionsModules(response.permissions)
    Auth.setLastUserData(this.state);
    this.props.setModulos(response.modules)
    this.setState({
      pending_information: response.pending_information,
      loading: false,
    });
    if (response.pending_information) {
      localStorage.setItem(
        "menu",
        JSON.stringify(["", "submit", "", "", "", ""])
      );
    } else {
      localStorage.setItem(
        "menu",
        JSON.stringify(["submit", "", "", "", "", ""])
      );
    }

    // Consult User Information
    fetch(settings.backend.dataResponse, {
      method: "GET",
      headers: settings.headers_auth(Auth.getSessionToken()),
    })
      .then(FetchResponses.processResponse)
      .then(this.successDataResponse)
      .catch(this.failureDataResponse);
  };

  failureDataResponse = () => {
    this.setState({
      open: true,
      error_message: Messages.errorTryLater,
    });
  };

  
  subscribeToPush = async (fiscal_number) => {
    console.log('subscribeToPush: ', fiscal_number);
    try {
      if (!("Notification" in window) || !("serviceWorker" in navigator)) {
        //console.log("Las notificaciones no están soportadas.");
        return;
      }
  
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        //console.log("Permiso denegado para notificaciones.");
        return;
      }
  
      const registration = await navigator.serviceWorker.ready;
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: process.env.REACT_APP_VAPID_PUBLIC_KEY,
      });
      
      const subscriptionData = {
        user: fiscal_number,  // Enviar el ID del usuario
        endpoint: subscription.endpoint,
        keys: {
            p256dh: btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey("p256dh")))),
            auth: btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey("auth"))))
        }
      };
  
      // Enviar la suscripción al backend con el token del usuario
      await fetch(settings.backend.subscribeToPush, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(subscriptionData),
      });
      //console.log("suscrito a las notificaciones")
    } catch (error) {
      console.log('error: ', error);
    }
  };

  successDataResponse = (response) => {
    try {
      let full_name =
      `${response.first_name} ${response.last_name}`.toUpperCase();
      let first_name = response.first_name;
      let last_name = response.last_name;
      let { fiscal_number, email, phone, home_phone } = response;

      this.subscribeToPush(fiscal_number)

      let name_avatar = (
        first_name.charAt(0) + last_name.charAt(0)
      ).toUpperCase();
      
      Auth.setLastUserData(response);
      let object = {
        first_name,
        full_name,
        name_avatar,
        last_name,
        fiscal_number,
        email,
        phone,
        home_phone,
      };
      this.props.SetPerfil(object);
    } catch (error) {
      console.log('error: ', error);
    }
  };


  failureLogin = (error) => {
    Logger.error(error);
    Logger.info("Login Failed: " + JSON.stringify(error));
    let error_message = translateDetails(error.detail);
    if (error.detail.indexOf("total_intentos") != -1) {
      let data = JSON.parse(error.detail);
      if (+data.numero_intento == +data.total_intentos - 1) {
        error_message = translateDetails("Last attempt");
      } else if (+data.numero_intento == +data.total_intentos) {
        error_message = translateDetails("User still out of time");
      } else {
        error_message = translateDetails("Invalid password.");
      }
    }
    this.setState({
      open: true,
      error_message,
      loading: false,
    });
  };

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  element () {
    return (
      <div>
        <div className="login-main-container">
          <NavbarV2 login mainpage />

          <div className="login-content">
            <div className="login-card-container">
              <div className="login-card">
                <h1 className="login-card-title">Inicio de Sesión</h1>
                <form onSubmit={this.login}>
                  <div className="login-input">
                    <span>Cédula</span>
                    <input
                      type="text"
                      className="form-control"
                      field="fiscal_number"
                      onChange={this.handleChange}
                      id="fiscal_number"
                      placeholder="Ingresa tu número de identificación"
                      required
                    />
                  </div>

                  <div className="login-input">
                  <span>Contraseña</span>

                  <div className="input-wrapper">
                    <input
                      type={this.state.type}
                      className="form-control"
                      field="password"
                      onChange={this.handleChange}
                      id="password"
                      placeholder="Ingresa tu contraseña registrada"
                      required
                    />

                    <span 
                      className="input-icon" 
                      onClick={this.onClick}
                    >
                      <CustomIcons icon={this.state.show ? "eyeHide" : "eyeShow"} />
                    </span>
                  </div>

                  <Link to="/recuperar-clave" className="lnk-recuperar-clave">
                    Ayúdame a recordar mi contraseña
                  </Link>
                </div>


                  <div className="button-container">
                    <button
                      className="login-submit-btn"
                      disabled={!this.validateFields()}
                    >
                      Ingresar
                    </button>
                    <Link to="/registro" className="login-register-lnk">
                      Quiero registrarme
                    </Link>
                  </div>
                </form>
              </div>
              <div className="alternative-logins">
               {this.state.parameters.data.toggle.google && (
                <button>
                  <CustomIcons icon='googleLogin' className='icon-login'/>
                  Ingresar con cuenta de Google
                </button>)
                }
               {this.state.parameters.data.toggle.facebook && (
                <button> 
                  <CustomIcons icon='facebookLogin' className='icon-login'/>Ingresar con cuenta de Facebook
                </button>)
                }
              </div>
            </div>

            <div className="login-img-container">
              <div className="login-img-text">
                <h2>{this.state.parameters.title}</h2>
                <p>{this.state.parameters.content}</p>
              </div>
              
              <div class="circle-container">
                <img src={this.state.parameters.imagen} alt="login img" class="cutout-image"/>
              </div>
            </div>

          </div>
        </div>
        <Footerv2 />
        <Error
          open={this.state.open}
          error_message={this.state.error_message}
          handleClose={this.handleClose}
        />
        {this.state.loading && <PageLoader/>}
      </div>
    );
  }
  render() {
    if (this.state.pending_information) {
        Logger.info("Redirect to perfil");
        return <Redirect to={"/perfil"} />;
    }
    return Auth.loginRedirect(this.element(), this.state.modules);
  }
}


const mapStateToProps = (state) => ({
  perfil: state.perfil.perfilInformation,
  PDF: state.PDF.PDF,
  modulos: state.modulos.modulos, 
});

export default connect(mapStateToProps, { SetPerfil, setDataLandingTotal, setModulos})(
  Loginv2
);

